enum FlexProjectStatus {
  InProgress = 1,
  OnHold = 2,
  Completed = 3,
  Cancelled = 4,
}
export default FlexProjectStatus
